<template>
  <div
    v-if="addressType?.sub_label"
    v-tooltip="addressType?.sub_label"
    class="flex h-6-5 w-6-5 cursor-pointer items-center justify-center rounded-full px-1 py-1 text-right text-xs font-semibold whitespace-nowrap"
    :class="{
      'bg-blue-100/50': addressTypeLabel === TYPE_COLORS.commercial,
      'bg-yellow-100/50': addressTypeLabel === TYPE_COLORS.residential,
      'bg-green-100/50': addressTypeLabel === TYPE_COLORS.deliverable,
    }"
  >
    <icon-base :icon="icon" :icon-color="UTIL_COLORS.SUCCESS" opacity="1" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { UTIL_COLORS } from "@/helpers/constants";
import IconAddressCommercial from "@/components/icons/IconAddressCommercial.vue";
import IconAddressDeliverable from "@/components/icons/IconAddressDeliverable.vue";
import IconAddressResidential from "@/components/icons/IconAddressResidential.vue";

import type { Task } from "@/models/commercialData/Middesk";
import type { PropType } from "vue";

const props = defineProps({
  addressType: {
    type: Object as PropType<Task>,
    required: true,
  },
  deliverable: {
    type: Boolean,
    required: false,
  },
});

const TYPE_COLORS = {
  commercial: "commercial",
  residential: "residential",
  deliverable: "deliverable",
};

const addressTypeLabel = computed(() =>
  props.addressType?.sub_label?.toLowerCase()
);

const icon = computed(() => {
  if (props.addressType.sub_label === "Commercial") {
    return IconAddressCommercial;
  }
  if (props.addressType.sub_label === "Residential") {
    return IconAddressResidential;
  }
  return IconAddressDeliverable;
});
</script>
